import { FC, useEffect, useState } from 'react';
import { LearnosityRequest } from '../../models/LearnosityRequest';
import { DataView } from 'primereact/dataview';
import {
  useLearnosityItemsInitialization,
  type LearnosityInitializationRefetch,
} from '../../custom-hooks/useLearnosityItemsInitialization';

interface Props {
  request: LearnosityRequest;
  enabled?: boolean;
  setLoading: (state: boolean) => void;
  itemRefs: string[];
  refetchInitialization: LearnosityInitializationRefetch;
  onFailure?: (error: unknown) => void;
}

const ExitSlipPrintModalWrapper: FC<Props> = ({
  request,
  enabled = true,
  setLoading,
  itemRefs,
  refetchInitialization,
  onFailure,
}) => {
  const [itemContainerKey, setItemContainerKey] = useState(0);
  const { status } = useLearnosityItemsInitialization({
    initObj: request,
    enabled: enabled && itemRefs.length > 0,
    restartKey: JSON.stringify(itemRefs),
    assessmentType: 'exit_slip_print',
    refetchInitialization,
    onFailure,
    getContainer: () => document.getElementById('print-exit-slip-problems'),
    onReady: () => setLoading(false),
  });
  useEffect(() => {
    if (status !== 'idle') setLoading(status === 'initializing' || status === 'retry_wait');
  }, [status, setLoading]);
  useEffect(() => {
    if (status === 'retry_wait' && request.request.rendering_type === 'inline') {
      setItemContainerKey(key => key + 1);
    }
  }, [status, request.request.rendering_type]);

  let itemNumber = 1;

  const exitSlipTemplate = (reference: string) => {
    return (
      <div className={`flex w-full nc_exit-slip ${itemNumber % 2 === 0 ? 'break-page' : ''}`} id={reference}>
        <h1 id="exit-slip-index">{itemNumber++}</h1>
        <span key={reference} className="learnosity-item" data-reference={reference}></span>
      </div>
    );
  };

  return (
    <div className="nc_inline-exit-slip align-self-center" id="print-exit-slip-problems">
      {itemRefs.length > 0 && <DataView key={itemContainerKey} value={itemRefs} itemTemplate={exitSlipTemplate} />}
    </div>
  );
};

export default ExitSlipPrintModalWrapper;
